import { publicAssetUrl } from '@/utils/publicAssetUrl';
export const CAR_IMAGE_PLACEHOLDER = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="800" height="500"><rect fill="#222" width="100%" height="100%"/><text x="50%" y="50%" fill="#aaa" font-size="28" text-anchor="middle" dy=".3em">Autó kép</text></svg>');
export const carsData = [
    {
        kepUrl: publicAssetUrl("/pictures/imported/23608717-32316789.jpg?v=7"),
        imageUrls: ["/pictures/imported/23608717-32316789.jpg?v=7", "/pictures/imported/23608717-32316790.jpg?v=7", "/pictures/imported/23608717-32316791.jpg?v=7", "/pictures/imported/23608717-32316792.jpg?v=7", "/pictures/imported/23608717-32316793.jpg?v=7", "/pictures/imported/23608717-32316794.jpg?v=7", "/pictures/imported/23608717-32316795.jpg?v=7", "/pictures/imported/23608717-32316796.jpg?v=7", "/pictures/imported/23608717-32316799.jpg?v=7", "/pictures/imported/23608717-32316803.jpg?v=7", "/pictures/imported/23608717-32316805.jpg?v=7"],
        "id": "0c65307e-50ce-5412-aa9b-543433d5245c",
        "marka": "AUDI",
        "modell": "A6 3.0 V6 TDI DPF multitronic",
        "evjarat": 2012,
        "evjaratHonap": 10,
        "ar": 3890000,
        "futottKm": 295000,
        "uzemanyag": "Dízel",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "AUDI A6 3.0 V6 TDI DPF multitronic",
            "bodyType": "Sedan",
            "condition": "Kitűnő",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2012/10",
            "inspectionValidUntil": "2026/12",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2967,
            "powerKw": 150,
            "powerHp": 204,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1645,
            "totalWeightKg": 2225,
            "trunkCapacityLiter": 530,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "10%-tól elvihető",
            "cylinderLayout": "V",
            "gearboxDetail": "Fokozatmentes automata",
            "tireSummer": "225/55 R 17",
            "tireSummerRear": "225/55 R 17",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "memóriás vezetőülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "hátsó fejtámlák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "kulcsnélküli nyitórendszer",
                    "kulcs nélküli indítás",
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "guminyomás-ellenőrző rendszer",
                    "visszagurulás-gátló",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "bluetooth-os kihangosító",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "xenon fényszóró",
                    "menetfény",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "10%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "3 890 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 10 663"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2012/10"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "10%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "295 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 645 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 225 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "530 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 967 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "150 kW, 204 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "V"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Fokozatmentes automata"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2026/12"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "225/55 R 17"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "225/55 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "memóriás vezetőülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "hátsó fejtámlák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "kulcsnélküli nyitórendszer",
                            "kulcs nélküli indítás",
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "guminyomás-ellenőrző rendszer",
                            "visszagurulás-gátló",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "xenon fényszóró",
                            "menetfény",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "bluetooth-os kihangosító",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "10%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "295 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "150 kW, 204 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "530 liter"
                    }
                ],
                "priceText": "3 890 000 Ft",
                "priceEur": "€ 10 663",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/audi/a6/audi_a6_3.0_v6_tdi_dpf_multitronic-23608717"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23582099-31990525.jpg?v=7"),
        imageUrls: ["/pictures/imported/23582099-31990525.jpg?v=7", "/pictures/imported/23582099-31990526.jpg?v=7", "/pictures/imported/23582099-31990527.jpg?v=7", "/pictures/imported/23582099-31990528.jpg?v=7", "/pictures/imported/23582099-31990531.jpg?v=7", "/pictures/imported/23582099-31990533.jpg?v=7", "/pictures/imported/23582099-31990534.jpg?v=7", "/pictures/imported/23582099-31990536.jpg?v=7", "/pictures/imported/23582099-31990537.jpg?v=7"],
        "id": "dd40b13e-cce1-54fa-91b9-5f834558d60f",
        "marka": "AUDI",
        "modell": "A6 Avant 2.0 TFSI multitronic",
        "evjarat": 2005,
        "evjaratHonap": 0,
        "ar": 1690000,
        "futottKm": 345000,
        "uzemanyag": "Benzin",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "AUDI A6 Avant 2.0 TFSI multitronic",
            "bodyType": "Kombi",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2005",
            "inspectionValidUntil": "2027/8",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1984,
            "powerKw": 125,
            "powerHp": 170,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1620,
            "totalWeightKg": 2250,
            "trunkCapacityLiter": 565,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Fokozatmentes automata",
            "tireSummer": "205/60 R 16",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "bőrkormány",
                    "függönylégzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "hátsó fejtámlák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "guminyomás-ellenőrző rendszer",
                    "GPS nyomkövető",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "xenon fényszóró",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "rendszeresen karbantartott",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "1 690 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 4 632"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2005"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Kombi"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "345 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 620 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 250 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "565 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 984 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "125 kW, 170 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Fokozatmentes automata"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/8"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "205/60 R 16"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "guminyomás-ellenőrző rendszer",
                            "GPS nyomkövető",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Beltér",
                        "items": [
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "bőrkormány",
                            "függönylégzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "hátsó fejtámlák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "xenon fényszóró",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "rendszeresen karbantartott",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "345 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "125 kW, 170 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "565 liter"
                    }
                ],
                "priceText": "1 690 000 Ft",
                "priceEur": "€ 4 632",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/audi/a6/audi_a6_avant_2.0_tfsi_multitronic-23582099"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23599186-32201635.jpg?v=7"),
        imageUrls: ["/pictures/imported/23599186-32201635.jpg?v=7", "/pictures/imported/23599186-32201639.jpg?v=7", "/pictures/imported/23599186-32201641.jpg?v=7", "/pictures/imported/23599186-32201653.jpg?v=7", "/pictures/imported/23599186-32201664.jpg?v=7", "/pictures/imported/23599186-32201665.jpg?v=7", "/pictures/imported/23599186-32201667.jpg?v=7", "/pictures/imported/23599186-32201672.jpg?v=7", "/pictures/imported/23599186-32201674.jpg?v=7"],
        "id": "6a3de9db-913e-56f3-99da-5392f5eaa7d5",
        "marka": "BMW",
        "modell": "318 318i (Automata)",
        "evjarat": 2008,
        "evjaratHonap": 0,
        "ar": 1790000,
        "futottKm": 270000,
        "uzemanyag": "Benzin",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "BMW 318 318i (Automata)",
            "bodyType": "Sedan",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2008",
            "inspectionValidUntil": "2027/10",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1995,
            "powerKw": 105,
            "powerHp": 143,
            "torqueNm": 0,
            "drivetrain": "Hátsó kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1390,
            "totalWeightKg": 1910,
            "trunkCapacityLiter": 460,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata (6 fokozatú tiptronic)",
            "tireSummer": "205/55 R 16",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "bőrkormány",
                    "hátsó oldal légzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "elektromosan behajtható külső tükrök",
                    "ködlámpa",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "1 790 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 4 907"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2008"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "270 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 390 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 910 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "460 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 995 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "105 kW, 143 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Hátsó kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata (6 fokozatú tiptronic)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/10"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "205/55 R 16"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "bőrkormány",
                            "hátsó oldal légzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "elektromosan behajtható külső tükrök",
                            "ködlámpa",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "270 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "105 kW, 143 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "460 liter"
                    }
                ],
                "priceText": "1 790 000 Ft",
                "priceEur": "€ 4 907",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/bmw/318/bmw_318_318i_automata-23599186"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23541238-31493875.jpg?v=7"),
        imageUrls: ["/pictures/imported/23541238-31493875.jpg?v=7", "/pictures/imported/23541238-31493876.jpg?v=7", "/pictures/imported/23541238-31493880.jpg?v=7", "/pictures/imported/23541238-31493886.jpg?v=7", "/pictures/imported/23541238-31493888.jpg?v=7", "/pictures/imported/23541238-31493889.jpg?v=7", "/pictures/imported/23541238-31493890.jpg?v=7", "/pictures/imported/23541238-31493891.jpg?v=7", "/pictures/imported/23541238-31493892.jpg?v=7"],
        "id": "672dab14-f58f-5a6f-8d96-9f5c15c5b1a7",
        "marka": "BMW",
        "modell": "520 520i",
        "evjarat": 2004,
        "evjaratHonap": 0,
        "ar": 2370000,
        "futottKm": 243000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "BMW 520 520i",
            "bodyType": "Sedan",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2004",
            "inspectionValidUntil": "2026/12",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2171,
            "powerKw": 125,
            "powerHp": 170,
            "torqueNm": 0,
            "drivetrain": "Hátsó kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1485,
            "totalWeightKg": 2025,
            "trunkCapacityLiter": 520,
            "climate": "Automata klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (6 fokozatú)",
            "tireSummer": "225/55 R 17",
            "tireSummerRear": "225/55 R 17",
            "roof": "",
            "equipment": {
                "comfort": [
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "tempomat",
                    "guminyomás-ellenőrző rendszer",
                    "GPS nyomkövető",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "DVD",
                    "GPS (navigáció)",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "ködlámpa",
                    "xenon fényszóró",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 370 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 6 496"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2004"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "243 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 485 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 025 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "520 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Automata klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 171 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "125 kW, 170 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Hátsó kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (6 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2026/12"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "225/55 R 17"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "225/55 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "tempomat",
                            "guminyomás-ellenőrző rendszer",
                            "GPS nyomkövető",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Beltér",
                        "items": [
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "ködlámpa",
                            "xenon fényszóró",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "DVD",
                            "GPS (navigáció)",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "243 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "125 kW, 170 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "520 liter"
                    }
                ],
                "priceText": "2 370 000 Ft",
                "priceEur": "€ 6 496",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/bmw/520/bmw_520_520i_sor_6_benzin_kezi_6-os_valto-23541238"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23541049-31491057.jpg?v=7"),
        imageUrls: ["/pictures/imported/23541049-31491057.jpg?v=7", "/pictures/imported/23541049-31491060.jpg?v=7", "/pictures/imported/23541049-31491061.jpg?v=7", "/pictures/imported/23541049-31491062.jpg?v=7", "/pictures/imported/23541049-31491063.jpg?v=7", "/pictures/imported/23541049-31491064.jpg?v=7", "/pictures/imported/23541049-31491066.jpg?v=7", "/pictures/imported/23541049-31491067.jpg?v=7", "/pictures/imported/23541049-31491069.jpg?v=7", "/pictures/imported/23541049-31491072.jpg?v=7"],
        "id": "95ca17b9-c20d-5fe6-a1a8-af72d7615c97",
        "marka": "BMW",
        "modell": "523 523i (Automata)",
        "evjarat": 2007,
        "evjaratHonap": 0,
        "ar": 2990000,
        "futottKm": 276000,
        "uzemanyag": "Benzin",
        "valto": "Automatikus",
        "leiras": "Az autó kívül-belül a szép állapotban van. Kényelmes, erős, klasszikus hathengeres BMW, igényes világos bőrbelsővel. 0km es vadonat új gumik. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "BMW 523 523i (Automata)",
            "bodyType": "Sedan",
            "condition": "Kitűnő",
            "origin": "",
            "color": "",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2007",
            "inspectionValidUntil": "2028/9",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2497,
            "powerKw": 140,
            "powerHp": 190,
            "torqueNm": 0,
            "drivetrain": "Hátsó kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1600,
            "totalWeightKg": 2085,
            "trunkCapacityLiter": 520,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata (6 fokozatú tiptronic)",
            "tireSummer": "245/35 R 19",
            "tireSummerRear": "245/35 R 19",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "faberakás",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "tempomat",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány"
                ],
                "multimedia": [
                    "DVD",
                    "GPS (navigáció)",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "xenon fényszóró",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "garantált km futás",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 990 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 8 196"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2007"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "276 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 600 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 085 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "520 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 497 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "140 kW, 190 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Hátsó kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata (6 fokozatú tiptronic)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2028/9"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "245/35 R 19"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "245/35 R 19"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "faberakás",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "tempomat",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "xenon fényszóró",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "DVD",
                            "GPS (navigáció)",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "garantált km futás",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "276 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "140 kW, 190 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "520 liter"
                    }
                ],
                "priceText": "2 990 000 Ft",
                "priceEur": "€ 8 196",
                "description": "Az autó kívül-belül a szép állapotban van. Kényelmes, erős, klasszikus hathengeres BMW, igényes világos bőrbelsővel. 0km es vadonat új gumik. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/bmw/523/bmw_523_523i_automata_nagy_navigacio_sor_6_benzin_facelift-23541049"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23541379-31495476.jpg?v=7"),
        imageUrls: ["/pictures/imported/23541379-31495476.jpg?v=7", "/pictures/imported/23541379-31495481.jpg?v=7", "/pictures/imported/23541379-31495484.jpg?v=7", "/pictures/imported/23541379-31495488.jpg?v=7", "/pictures/imported/23541379-31495491.jpg?v=7", "/pictures/imported/23541379-31495494.jpg?v=7", "/pictures/imported/23541379-31495498.jpg?v=7", "/pictures/imported/23541379-31495500.jpg?v=7", "/pictures/imported/23541379-31495503.jpg?v=7", "/pictures/imported/23541379-31495506.jpg?v=7"],
        "id": "07b5a728-4729-591d-a172-c939613d50c4",
        "marka": "BMW",
        "modell": "530 530i",
        "evjarat": 2008,
        "evjaratHonap": 12,
        "ar": 3290000,
        "futottKm": 271000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Ritkább, kézi 6 sebességes BMW 530i, a 3.0 literes sorhatos szívó benzines motorral, 272 lóerővel. Igazi klasszikus BMW-élmény: sorhatos benzines, kézi váltó és hátsókerék-hajtás. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "BMW 530 530i",
            "bodyType": "Sedan",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2008/12",
            "inspectionValidUntil": "2027/10",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2996,
            "powerKw": 200,
            "powerHp": 272,
            "torqueNm": 0,
            "drivetrain": "Hátsó kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1605,
            "totalWeightKg": 2090,
            "trunkCapacityLiter": 520,
            "climate": "Automata klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (6 fokozatú)",
            "tireSummer": "225/50 R 17",
            "tireSummerRear": "225/50 R 17",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "tempomat",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány",
                    "sportfutómű"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "DVD",
                    "GPS (navigáció)",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "xenon fényszóró",
                    "menetfény",
                    "bi-xenon fényszóró",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "3 290 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 9 018"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2008/12"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "271 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 605 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 090 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "520 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Automata klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 996 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "200 kW, 272 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Hátsó kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (6 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/10"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "225/50 R 17"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "225/50 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "tempomat",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány",
                            "sportfutómű"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "xenon fényszóró",
                            "menetfény",
                            "bi-xenon fényszóró",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "DVD",
                            "GPS (navigáció)",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "271 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "200 kW, 272 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "520 liter"
                    }
                ],
                "priceText": "3 290 000 Ft",
                "priceEur": "€ 9 018",
                "description": "Ritkább, kézi 6 sebességes BMW 530i, a 3.0 literes sorhatos szívó benzines motorral, 272 lóerővel. Igazi klasszikus BMW-élmény: sorhatos benzines, kézi váltó és hátsókerék-hajtás. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/bmw/530/bmw_530_530i_sor_6_szivo_benzin_kezi_6-os_valto-23541379"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23538770-31463599.jpg?v=7"),
        imageUrls: ["/pictures/imported/23538770-31463599.jpg?v=7", "/pictures/imported/23538770-31463600.jpg?v=7", "/pictures/imported/23538770-31463602.jpg?v=7", "/pictures/imported/23538770-31463603.jpg?v=7", "/pictures/imported/23538770-31463604.jpg?v=7", "/pictures/imported/23538770-31463605.jpg?v=7", "/pictures/imported/23538770-31463607.jpg?v=7", "/pictures/imported/23538770-31463608.jpg?v=7", "/pictures/imported/23538770-31463610.jpg?v=7", "/pictures/imported/23538770-31463614.jpg?v=7", "/pictures/imported/23538770-31463618.jpg?v=7", "/pictures/imported/23538770-31463620.jpg?v=7", "/pictures/imported/23538770-31463624.jpg?v=7", "/pictures/imported/23538770-31463625.jpg?v=7", "/pictures/imported/23538770-31463627.jpg?v=7", "/pictures/imported/23538770-31463629.jpg?v=7"],
        "id": "d166c7b4-b0b1-5593-b5f5-c1ce5793599a",
        "marka": "BMW",
        "modell": "X5 xDrive30d (Automata)",
        "evjarat": 2012,
        "evjaratHonap": 0,
        "ar": 4800000,
        "futottKm": 385000,
        "uzemanyag": "Dízel",
        "valto": "Automatikus",
        "leiras": "Panorámatető, fekete Nevada bőrbelső, fekete tetőkárpit, sportülések, elektromos-memóriás ülések, első-hátsó ülésfűtés, Professional nagy navigáció, HiFi, xenon, PDC, aktív kormányzás, váltófüles sportkormány, Shadow Line, Eibach rugók és Active Sound hanggenerátor.\n\n330.000 km-nél vezérlés cserélve, frissen cserélt fékekkel és vadonatúj gumiabroncsokkal.\n\nErős, kényelmes, nagyon jól felszerelt és megjelenésre is sportos X5. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "BMW X5 xDrive30d (Automata)",
            "bodyType": "Városi terepjáró (crossover)",
            "condition": "Kitűnő",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2012",
            "inspectionValidUntil": "2027/9",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2993,
            "powerKw": 180,
            "powerHp": 245,
            "torqueNm": 0,
            "drivetrain": "Összkerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 2075,
            "totalWeightKg": 2755,
            "trunkCapacityLiter": 620,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "Fekete",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata (8 fokozatú tiptronic)",
            "tireSummer": "275/40 R 20",
            "tireSummerRear": "315/35 R 20",
            "roof": "Nyitható panorámatető",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető első ülés",
                    "memóriás vezetőülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "fűthető első és hátsó ülések",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "hátsó fejtámlák",
                    "állítható kormány",
                    "fedélzeti komputer",
                    "kormányváltó",
                    "sportülések"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "guminyomás-ellenőrző rendszer",
                    "visszagurulás-gátló",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány",
                    "sebességfüggő szervokormány",
                    "sportfutómű"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "MP3 lejátszás",
                    "Hi-Fi"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "elektromosan behajtható külső tükrök",
                    "ködlámpa",
                    "xenon fényszóró",
                    "menetfény",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni",
                    "tolótető (napfénytető)"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "4 800 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 13 157"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2012"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Városi terepjáró (crossover)"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "385 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Kárpit színe (1)",
                                "value": "Fekete"
                            },
                            {
                                "label": "Kárpit színe (2)",
                                "value": "Fekete"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "2 075 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 755 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "620 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            },
                            {
                                "label": "Tető",
                                "value": "Nyitható panorámatető"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 993 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "180 kW, 245 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Összkerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata (8 fokozatú tiptronic)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/9"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "275/40 R 20"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "315/35 R 20"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető első ülés",
                            "memóriás vezetőülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "fűthető első és hátsó ülések",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "hátsó fejtámlák",
                            "állítható kormány",
                            "fedélzeti komputer",
                            "kormányváltó",
                            "sportülések"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "guminyomás-ellenőrző rendszer",
                            "visszagurulás-gátló",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány",
                            "sebességfüggő szervokormány",
                            "sportfutómű"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "elektromosan behajtható külső tükrök",
                            "ködlámpa",
                            "xenon fényszóró",
                            "menetfény",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni",
                            "tolótető (napfénytető)"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "MP3 lejátszás",
                            "Hi-Fi"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "385 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "180 kW, 245 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "620 liter"
                    }
                ],
                "priceText": "4 800 000 Ft",
                "priceEur": "€ 13 157",
                "description": "Panorámatető, fekete Nevada bőrbelső, fekete tetőkárpit, sportülések, elektromos-memóriás ülések, első-hátsó ülésfűtés, Professional nagy navigáció, HiFi, xenon, PDC, aktív kormányzás, váltófüles sportkormány, Shadow Line, Eibach rugók és Active Sound hanggenerátor.\n\n330.000 km-nél vezérlés cserélve, frissen cserélt fékekkel és vadonatúj gumiabroncsokkal.\n\nErős, kényelmes, nagyon jól felszerelt és megjelenésre is sportos X5. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/bmw/x5/bmw_x5_xdrive30d_automata_shadow_line-23538770"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23569848-31841700.jpg?v=7"),
        imageUrls: ["/pictures/imported/23569848-31841700.jpg?v=7", "/pictures/imported/23569848-31841701.jpg?v=7", "/pictures/imported/23569848-31841703.jpg?v=7", "/pictures/imported/23569848-31841707.jpg?v=7", "/pictures/imported/23569848-31841709.jpg?v=7", "/pictures/imported/23569848-31841710.jpg?v=7", "/pictures/imported/23569848-31841712.jpg?v=7", "/pictures/imported/23569848-31841713.jpg?v=7", "/pictures/imported/23569848-31841715.jpg?v=7"],
        "id": "ff3fa07e-04ed-5a76-aba3-730f524ce9f6",
        "marka": "CHEVROLET",
        "modell": "AVEO 1.2 16V LS",
        "evjarat": 2008,
        "evjaratHonap": 12,
        "ar": 570000,
        "futottKm": 117000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "CHEVROLET AVEO 1.2 16V LS",
            "bodyType": "Ferdehátú",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 3,
            "seats": 5,
            "firstRegistration": "2008/12",
            "inspectionValidUntil": "2026/12",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1206,
            "powerKw": 62,
            "powerHp": 84,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1093,
            "totalWeightKg": 1503,
            "trunkCapacityLiter": 220,
            "climate": "",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (5 fokozatú)",
            "tireSummer": "185/55 R 15",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "plüss kárpit",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák"
                ],
                "safety": [
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "elektromos ablak elöl"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "570 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 1 562"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2008/12"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Ferdehátú"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "117 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "3"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 093 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 503 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "220 liter"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 206 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "62 kW, 84 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (5 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2026/12"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "185/55 R 15"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "plüss kárpit",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "elektromos ablak elöl"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "117 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "62 kW, 84 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "220 liter"
                    }
                ],
                "priceText": "570 000 Ft",
                "priceEur": "€ 1 562",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/chevrolet/aveo/chevrolet_aveo_1.2_16v_ls-23569848"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23613034-32367892.jpg?v=7"),
        imageUrls: ["/pictures/imported/23613034-32367892.jpg?v=7", "/pictures/imported/23613034-32367893.jpg?v=7", "/pictures/imported/23613034-32367894.jpg?v=7", "/pictures/imported/23613034-32367895.jpg?v=7", "/pictures/imported/23613034-32367897.jpg?v=7", "/pictures/imported/23613034-32367898.jpg?v=7", "/pictures/imported/23613034-32367899.jpg?v=7", "/pictures/imported/23613034-32367900.jpg?v=7", "/pictures/imported/23613034-32367902.jpg?v=7", "/pictures/imported/23613034-32367903.jpg?v=7", "/pictures/imported/23613034-32367905.jpg?v=7", "/pictures/imported/23613034-32367906.jpg?v=7"],
        "id": "c48a7190-9e81-5fb5-a19a-61ec96689808",
        "marka": "CHEVROLET",
        "modell": "CAPTIVA 2.2 D LT (Manuális, 2014)",
        "evjarat": 2014,
        "evjaratHonap": 0,
        "ar": 3270000,
        "futottKm": 213000,
        "uzemanyag": "Dízel",
        "valto": "Manuális",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "CHEVROLET CAPTIVA 2.2 D LT",
            "bodyType": "Városi terepjáró (crossover)",
            "condition": "Normál",
            "origin": "",
            "color": "Ezüst (metál)",
            "doors": 5,
            "seats": 7,
            "firstRegistration": "2014",
            "inspectionValidUntil": "2027/3",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2231,
            "powerKw": 135,
            "powerHp": 184,
            "torqueNm": 0,
            "drivetrain": "Összkerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1953,
            "totalWeightKg": 2513,
            "trunkCapacityLiter": 97,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (6 fokozatú)",
            "tireSummer": "235/60 R 17",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "centrálzár",
                    "riasztó",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "elektromosan behajtható külső tükrök",
                    "ködlámpa",
                    "xenon fényszóró",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "fűthető tükör",
                    "könnyűfém felni",
                    "színezett üveg"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "3 270 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 8 963"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2014"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Városi terepjáró (crossover)"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "213 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "7 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Ezüst (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 953 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 513 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "97 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 231 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "135 kW, 184 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Összkerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (6 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/3"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "235/60 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "centrálzár",
                            "riasztó",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "elektromosan behajtható külső tükrök",
                            "ködlámpa",
                            "xenon fényszóró",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "fűthető tükör",
                            "könnyűfém felni",
                            "színezett üveg"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "213 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "135 kW, 184 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "97 liter"
                    }
                ],
                "priceText": "3 270 000 Ft",
                "priceEur": "€ 8 963",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/chevrolet/captiva/chevrolet_captiva_2.2_d_lt_7_szemelyes_kezi_valtos-23613034"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23613159-32369344.jpg?v=7"),
        imageUrls: ["/pictures/imported/23613159-32369344.jpg?v=7", "/pictures/imported/23613159-32369345.jpg?v=7", "/pictures/imported/23613159-32369347.jpg?v=7", "/pictures/imported/23613159-32369349.jpg?v=7", "/pictures/imported/23613159-32369350.jpg?v=7", "/pictures/imported/23613159-32369352.jpg?v=7", "/pictures/imported/23613159-32369354.jpg?v=7", "/pictures/imported/23613159-32369355.jpg?v=7", "/pictures/imported/23613159-32369357.jpg?v=7"],
        "id": "0d155238-4891-563c-959a-8fd5ebcaeab2",
        "marka": "CHEVROLET",
        "modell": "CAPTIVA 2.2 D LT (Nagy navis, Automata, 2013)",
        "evjarat": 2013,
        "evjaratHonap": 0,
        "ar": 3270000,
        "futottKm": 177000,
        "uzemanyag": "Dízel",
        "valto": "Automatikus",
        "leiras": "Megkímélt állapotú Chevrolet Captiva, 7 személyes kivitelben. Kifejezetten tágas és kényelmes autó, családi használatra ideális, hátul is bőséges hellyel és jól variálható ülésekkel. Magas üléspozíciója és összkerékhajtása stabil, magabiztos közlekedést biztosít minden útviszony mellett.\n\nA típus megbízható, kényelmes utazóautóként ismert, erős és nyomatékos motorral, ami a nagyobb kasznihoz is bőven elegendő. Fullos bőr belső, nagyméretű Tesla stílusú kijelző és vonóhorog is van rajta. Jól felszerelt, kényelmes és praktikus választás mindennapi használatra vagy hosszabb utakra. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "CHEVROLET CAPTIVA 2.2 D LT",
            "bodyType": "Városi terepjáró (crossover)",
            "condition": "Kitűnő",
            "origin": "",
            "color": "Fehér",
            "doors": 5,
            "seats": 7,
            "firstRegistration": "2013",
            "inspectionValidUntil": "2026/10",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2231,
            "powerKw": 135,
            "powerHp": 184,
            "torqueNm": 0,
            "drivetrain": "Összkerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1953,
            "totalWeightKg": 2513,
            "trunkCapacityLiter": 97,
            "climate": "Digitális klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata",
            "tireSummer": "235/60 R 18",
            "tireSummerRear": "235/60 R 18",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "elektromos ülésállítás vezetőoldal",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "kikapcsolható légzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "tolatókamera",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány"
                ],
                "multimedia": [
                    "memóriakártya-olvasó",
                    "bluetooth-os kihangosító",
                    "USB csatlakozó",
                    "HDMI bemenet",
                    "MP3 lejátszás",
                    "MP4 lejátszás",
                    "érintőkijelző",
                    "Android Auto",
                    "multifunkcionális kijelző"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "xenon fényszóró",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni",
                    "vonóhorog"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "rendszeresen karbantartott",
                    "törzskönyv",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "3 270 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 8 963"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2013"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Városi terepjáró (crossover)"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "177 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "7 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fehér"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 953 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 513 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "97 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 231 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "135 kW, 184 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Összkerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2026/10"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "235/60 R 18"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "235/60 R 18"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "elektromos ülésállítás vezetőoldal",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "kikapcsolható légzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "tolatókamera",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "xenon fényszóró",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni",
                            "vonóhorog"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "memóriakártya-olvasó",
                            "bluetooth-os kihangosító",
                            "USB csatlakozó",
                            "HDMI bemenet",
                            "MP3 lejátszás",
                            "MP4 lejátszás",
                            "érintőkijelző",
                            "Android Auto",
                            "multifunkcionális kijelző"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "rendszeresen karbantartott",
                            "törzskönyv",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "177 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "135 kW, 184 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "97 liter"
                    }
                ],
                "priceText": "3 270 000 Ft",
                "priceEur": "€ 8 963",
                "description": "Megkímélt állapotú Chevrolet Captiva, 7 személyes kivitelben. Kifejezetten tágas és kényelmes autó, családi használatra ideális, hátul is bőséges hellyel és jól variálható ülésekkel. Magas üléspozíciója és összkerékhajtása stabil, magabiztos közlekedést biztosít minden útviszony mellett.\n\nA típus megbízható, kényelmes utazóautóként ismert, erős és nyomatékos motorral, ami a nagyobb kasznihoz is bőven elegendő. Fullos bőr belső, nagyméretű Tesla stílusú kijelző és vonóhorog is van rajta. Jól felszerelt, kényelmes és praktikus választás mindennapi használatra vagy hosszabb utakra. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/chevrolet/captiva/chevrolet_captiva_2.2_d_lt_7_szemelyes_nagy_navis-23613159"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23612079-32356227.jpg?v=7"),
        imageUrls: ["/pictures/imported/23612079-32356227.jpg?v=7", "/pictures/imported/23612079-32356229.jpg?v=7", "/pictures/imported/23612079-32356230.jpg?v=7", "/pictures/imported/23612079-32356231.jpg?v=7", "/pictures/imported/23612079-32356232.jpg?v=7", "/pictures/imported/23612079-32356233.jpg?v=7", "/pictures/imported/23612079-32356234.jpg?v=7", "/pictures/imported/23612079-32356236.jpg?v=7", "/pictures/imported/23612079-32356237.jpg?v=7"],
        "id": "40fec81c-d4f3-5f7a-86ff-e70400712f72",
        "marka": "FORD",
        "modell": "MONDEO 2.0 TDCi Trend",
        "evjarat": 2008,
        "evjaratHonap": 0,
        "ar": 990000,
        "futottKm": 370000,
        "uzemanyag": "Dízel",
        "valto": "Manuális",
        "leiras": "Kilométeréhez képest kivételes állapotú, önmagát meghazudtoló autó.\n\nDigitklíma, tempomat, levehető vonóhorog, jó gumik, új fékek.\n\nFrissen szervizelve, vezérlés cserélve teljesen költségmentes állapotban.\n\nNem a kilométer számít, hanem az állapot ezt látni kell. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "FORD MONDEO 2.0 TDCi Trend",
            "bodyType": "Kombi",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2008",
            "inspectionValidUntil": "2027/10",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1997,
            "powerKw": 103,
            "powerHp": 140,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1501,
            "totalWeightKg": 2275,
            "trunkCapacityLiter": 554,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (6 fokozatú)",
            "tireSummer": "215/55 R 16",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "plüss kárpit",
                    "ülésmagasság állítás",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "centrálzár",
                    "szervokormány",
                    "vonóhorog - levehető fejjel"
                ],
                "multimedia": [],
                "exterior": [
                    "ködlámpa",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni",
                    "színezett üveg"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "990 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 2 714"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2008"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Kombi"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "370 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 501 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 275 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "554 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 997 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "103 kW, 140 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (6 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/10"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "215/55 R 16"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "plüss kárpit",
                            "ülésmagasság állítás",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "centrálzár",
                            "szervokormány",
                            "vonóhorog - levehető fejjel"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "ködlámpa",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni",
                            "színezett üveg"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "370 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "103 kW, 140 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "554 liter"
                    }
                ],
                "priceText": "990 000 Ft",
                "priceEur": "€ 2 714",
                "description": "Kilométeréhez képest kivételes állapotú, önmagát meghazudtoló autó.\n\nDigitklíma, tempomat, levehető vonóhorog, jó gumik, új fékek.\n\nFrissen szervizelve, vezérlés cserélve teljesen költségmentes állapotban.\n\nNem a kilométer számít, hanem az állapot ezt látni kell. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/ford/mondeo/ford_mondeo_2.0_tdci_trend_friss_vezerles_vonohorgos-23612079"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23599896-32209360.jpg?v=7"),
        imageUrls: ["/pictures/imported/23599896-32209360.jpg?v=7", "/pictures/imported/23599896-32209361.jpg?v=7", "/pictures/imported/23599896-32209362.jpg?v=7", "/pictures/imported/23599896-32209363.jpg?v=7", "/pictures/imported/23599896-32209364.jpg?v=7", "/pictures/imported/23599896-32209365.jpg?v=7", "/pictures/imported/23599896-32209366.jpg?v=7"],
        "id": "54af2771-2afc-5d2b-9f43-619fcd7144ec",
        "marka": "HONDA",
        "modell": "CIVIC 1.4i S Klima",
        "evjarat": 1998,
        "evjaratHonap": 0,
        "ar": 370000,
        "futottKm": 392000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Beszámolt autó. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "HONDA CIVIC 1.4i S Klima",
            "bodyType": "Sedan",
            "condition": "Normál",
            "origin": "",
            "color": "(metál)",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "1998",
            "inspectionValidUntil": "2028/8",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1396,
            "powerKw": 66,
            "powerHp": 90,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1083,
            "totalWeightKg": 1540,
            "trunkCapacityLiter": 410,
            "climate": "Manuális klíma",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (5 fokozatú)",
            "tireSummer": "185/60 R 14",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "plüss kárpit",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány"
                ],
                "safety": [
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "USB csatlakozó",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "könnyűfém felni"
                ],
                "other": [
                    "azonnal elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "370 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 1 014"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "1998"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "392 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Szín",
                                "value": "(metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 083 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 540 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "410 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Manuális klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 396 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "66 kW, 90 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (5 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2028/8"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "185/60 R 14"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "plüss kárpit",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "USB csatlakozó",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "azonnal elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "392 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "66 kW, 90 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "410 liter"
                    }
                ],
                "priceText": "370 000 Ft",
                "priceEur": "€ 1 014",
                "description": "Beszámolt autó. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/honda/civic/honda_civic_1.4i_s_klima_klimas_friss_muszaki-23599896"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23607366-32300159.jpg?v=7"),
        imageUrls: ["/pictures/imported/23607366-32300159.jpg?v=7", "/pictures/imported/23607366-32300160.jpg?v=7", "/pictures/imported/23607366-32300163.jpg?v=7", "/pictures/imported/23607366-32300164.jpg?v=7", "/pictures/imported/23607366-32300165.jpg?v=7", "/pictures/imported/23607366-32300166.jpg?v=7", "/pictures/imported/23607366-32300168.jpg?v=7", "/pictures/imported/23607366-32300170.jpg?v=7"],
        "id": "aaec1f6d-cd03-57c5-8c7e-cf8fb05778b8",
        "marka": "MAZDA",
        "modell": "6 2.0i TE Plus",
        "evjarat": 2009,
        "evjaratHonap": 0,
        "ar": 1570000,
        "futottKm": 258000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "MAZDA 6 2.0i TE Plus",
            "bodyType": "Ferdehátú",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2009",
            "inspectionValidUntil": "2027/2",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1999,
            "powerKw": 108,
            "powerHp": 147,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1295,
            "totalWeightKg": 1905,
            "trunkCapacityLiter": 519,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (6 fokozatú)",
            "tireSummer": "215/50 R 17",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "függönylégzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "tempomat",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "bluetooth-os kihangosító",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "ködlámpa",
                    "xenon fényszóró",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni",
                    "vonóhorog"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "rendszeresen karbantartott",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "1 570 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 4 303"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2009"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Ferdehátú"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "258 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 295 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 905 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "519 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 999 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "108 kW, 147 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (6 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/2"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "215/50 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "tempomat",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Beltér",
                        "items": [
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "függönylégzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "ködlámpa",
                            "xenon fényszóró",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni",
                            "vonóhorog"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "bluetooth-os kihangosító",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "rendszeresen karbantartott",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "258 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "108 kW, 147 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "519 liter"
                    }
                ],
                "priceText": "1 570 000 Ft",
                "priceEur": "€ 4 303",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/mazda/6/mazda_6_2.0i_te_plus_benzines-23607366"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23398014-29776853.jpg?v=7"),
        imageUrls: ["/pictures/imported/23398014-29776853.jpg?v=7", "/pictures/imported/23398014-29776855.jpg?v=7", "/pictures/imported/23398014-29776856.jpg?v=7", "/pictures/imported/23398014-29776859.jpg?v=7", "/pictures/imported/23398014-29776862.jpg?v=7", "/pictures/imported/23398014-29776866.jpg?v=7", "/pictures/imported/23398014-29776869.jpg?v=7", "/pictures/imported/23398014-29776871.jpg?v=7", "/pictures/imported/23398014-29776872.jpg?v=7", "/pictures/imported/23398014-29776874.jpg?v=7"],
        "id": "377f7dce-c1cb-5e20-9a7d-a9423a6c7c1a",
        "marka": "MERCEDES-BENZ",
        "modell": "C 180 Kompr. 'Special Edition' (Automata)",
        "evjarat": 2006,
        "evjaratHonap": 0,
        "ar": 1800000,
        "futottKm": 227000,
        "uzemanyag": "Benzin",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "MERCEDES-BENZ C 180 Kompr. 'Special Edition' (Automata)",
            "bodyType": "Sedan",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2006",
            "inspectionValidUntil": "2026/12",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1796,
            "powerKw": 105,
            "powerHp": 143,
            "torqueNm": 0,
            "drivetrain": "Hátsó kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1430,
            "totalWeightKg": 1965,
            "trunkCapacityLiter": 455,
            "climate": "Automata klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata (5 fokozatú tiptronic)",
            "tireSummer": "225/45 R 17",
            "tireSummerRear": "225/45 R 17",
            "roof": "",
            "equipment": {
                "comfort": [
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "bőrkormány",
                    "függönylégzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "tempomat",
                    "centrálzár",
                    "sportfutómű"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "elektromosan behajtható külső tükrök",
                    "ködlámpa",
                    "xenon fényszóró",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "fűthető tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "1 800 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 4 934"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2006"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "227 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 430 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 965 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "455 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Automata klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 796 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "105 kW, 143 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Hátsó kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata (5 fokozatú tiptronic)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2026/12"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "225/45 R 17"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "225/45 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "bőrkormány",
                            "függönylégzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "tempomat",
                            "centrálzár",
                            "sportfutómű"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "elektromosan behajtható külső tükrök",
                            "ködlámpa",
                            "xenon fényszóró",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "fűthető tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "227 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "105 kW, 143 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "455 liter"
                    }
                ],
                "priceText": "1 800 000 Ft",
                "priceEur": "€ 4 934",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/mercedes-benz/c_180/mercedes-benz_c_180_kompr_special_edition_automata-23398014"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23195117-27348220.jpg?v=7"),
        imageUrls: ["/pictures/imported/23195117-27348220.jpg?v=7", "/pictures/imported/23195117-27348221.jpg?v=7", "/pictures/imported/23195117-27348222.jpg?v=7", "/pictures/imported/23195117-27348223.jpg?v=7", "/pictures/imported/23195117-27348224.jpg?v=7", "/pictures/imported/23195117-27348225.jpg?v=7", "/pictures/imported/23195117-27348227.jpg?v=7", "/pictures/imported/23195117-27348228.jpg?v=7", "/pictures/imported/23195117-27348229.jpg?v=7", "/pictures/imported/23195117-27348231.jpg?v=7", "/pictures/imported/23195117-27348232.jpg?v=7", "/pictures/imported/23195117-27348233.jpg?v=7", "/pictures/imported/23195117-27348234.jpg?v=7", "/pictures/imported/23195117-27348236.jpg?v=7"],
        "id": "603c142c-d239-5bf3-91d9-cc7b9fdbc6bd",
        "marka": "MERCEDES-BENZ",
        "modell": "VITO 116 CDI Mixto L (Automata)",
        "evjarat": 2016,
        "evjaratHonap": 0,
        "ar": 9900000,
        "futottKm": 159000,
        "uzemanyag": "Dízel",
        "valto": "Automatikus",
        "leiras": "Megkímélt, kiváló műszaki és esztétikai állapotú Mercedes Vito eladó. A 163 lóerős dízelmotorhoz 7 fokozatú automata váltó társul, amely kényelmes és gazdaságos utazást biztosít.\n\nRendszeresen szervizelt, időben elvégzett olajcserékkel, karbantartott váltóval és új fékekkel. Jelenleg semmilyen ráfordítást nem igényel.\n\nFőbb extrák: Alpine Style prémium multimédia (közel 1 millió Ft érték), bőr belső, ülésfűtés, tempomat, első-hátsó parkolóradar, elektromos kézifék, sötétített üvegek, tetősín, fekete alufelnik és 2 tonnás vonóhorog.\n\n5 személyes, nagy rakodótérrel, igényes állapotban. Csak bele kell ülni és használni. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "MERCEDES-BENZ VITO 116 CDI Mixto L (Automata)",
            "bodyType": "Körbeüvegezett",
            "condition": "Kitűnő",
            "origin": "",
            "color": "Barna (metál)",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2016",
            "inspectionValidUntil": "2027/1",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 2143,
            "powerKw": 120,
            "powerHp": 163,
            "torqueNm": 380,
            "drivetrain": "Hátsó kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1825,
            "totalWeightKg": 2800,
            "trunkCapacityLiter": 0,
            "climate": "Automata klíma",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "",
            "gearboxDetail": "Automata (7 fokozatú tiptronic]",
            "tireSummer": "",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető ülés",
                    "függönylégzsák",
                    "oldallégzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "centrálzár",
                    "fedélzeti komputer",
                    "szervokormány"
                ],
                "safety": [
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "riasztó",
                    "tempomat"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "Hi-Fi"
                ],
                "exterior": [
                    "elektromos ablak",
                    "elektromos tükör",
                    "fűthető tükör",
                    "könnyűfém felni",
                    "színezett üveg",
                    "vonóhorog"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "első tulajdonostól",
                    "garázsban tartott",
                    "keveset futott"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "9 900 000 Ft + 27% ÁFA bruttó: 12 573 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 27 137 + 27% ÁFA bruttó: € 34 464"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2016"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Körbeüvegezett"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "159 000 km"
                            },
                            {
                                "label": "Szállítható személyek",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Szín",
                                "value": "Barna (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 825 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 800 kg"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Automata klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Motor",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "2 143 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "120 kW, 163 LE"
                            },
                            {
                                "label": "Maximális nyomaték",
                                "value": "380 Nm (38,7 mkp)"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Hátsó kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata (7 fokozatú tiptronic]"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/1"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető ülés",
                            "függönylégzsák",
                            "oldallégzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "centrálzár",
                            "fedélzeti komputer",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "Hi-Fi"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "riasztó",
                            "tempomat"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "elektromos ablak",
                            "elektromos tükör",
                            "fűthető tükör",
                            "könnyűfém felni",
                            "színezett üveg",
                            "vonóhorog"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "első tulajdonostól",
                            "garázsban tartott",
                            "keveset futott"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "159 000 km"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "120 kW, 163 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    }
                ],
                "priceText": "9 900 000 Ft + 27% ÁFA bruttó: 12 573 000 Ft",
                "priceEur": "€ 27 137 + 27% ÁFA bruttó: € 34 464",
                "description": "Megkímélt, kiváló műszaki és esztétikai állapotú Mercedes Vito eladó. A 163 lóerős dízelmotorhoz 7 fokozatú automata váltó társul, amely kényelmes és gazdaságos utazást biztosít.\n\nRendszeresen szervizelt, időben elvégzett olajcserékkel, karbantartott váltóval és új fékekkel. Jelenleg semmilyen ráfordítást nem igényel.\n\nFőbb extrák: Alpine Style prémium multimédia (közel 1 millió Ft érték), bőr belső, ülésfűtés, tempomat, első-hátsó parkolóradar, elektromos kézifék, sötétített üvegek, tetősín, fekete alufelnik és 2 tonnás vonóhorog.\n\n5 személyes, nagy rakodótérrel, igényes állapotban. Csak bele kell ülni és használni. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/kishaszonjarmu/mercedes-benz/vito/mercedes-benz_vito_116_cdi_mixto_l_automata-23195117"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23594875-32152390.jpg?v=7"),
        imageUrls: ["/pictures/imported/23594875-32152390.jpg?v=7", "/pictures/imported/23594875-32152391.jpg?v=7", "/pictures/imported/23594875-32152392.jpg?v=7", "/pictures/imported/23594875-32152393.jpg?v=7", "/pictures/imported/23594875-32152394.jpg?v=7", "/pictures/imported/23594875-32152395.jpg?v=7", "/pictures/imported/23594875-32152396.jpg?v=7", "/pictures/imported/23594875-32152397.jpg?v=7", "/pictures/imported/23594875-32152398.jpg?v=7"],
        "id": "aee221e7-ad51-5349-b8b9-256112a85093",
        "marka": "NISSAN",
        "modell": "X-TRAIL 2.0 Comfort Columbia 2WD",
        "evjarat": 2006,
        "evjaratHonap": 0,
        "ar": 2000000,
        "futottKm": 240000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "NISSAN X-TRAIL 2.0 Comfort Columbia 2WD",
            "bodyType": "Városi terepjáró (crossover)",
            "condition": "Kitűnő",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2006",
            "inspectionValidUntil": "2027/6",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1998,
            "powerKw": 103,
            "powerHp": 140,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1485,
            "totalWeightKg": 2000,
            "trunkCapacityLiter": 410,
            "climate": "Automata klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (5 fokozatú)",
            "tireSummer": "215/65 R 16",
            "tireSummerRear": "",
            "roof": "Nyitható panorámatető",
            "equipment": {
                "comfort": [
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 000 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 5 482"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2006"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Városi terepjáró (crossover)"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "240 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 485 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 000 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "410 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Automata klíma"
                            },
                            {
                                "label": "Tető",
                                "value": "Nyitható panorámatető"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 998 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "103 kW, 140 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (5 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/6"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "215/65 R 16"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "240 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "103 kW, 140 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "410 liter"
                    }
                ],
                "priceText": "2 000 000 Ft",
                "priceEur": "€ 5 482",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/nissan/x-trail/nissan_x-trail_2.0_comfort_columbia_2wd_benzines-23594875"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23625292-32521997.jpg?v=7"),
        imageUrls: ["/pictures/imported/23625292-32521997.jpg?v=7", "/pictures/imported/23625292-32521998.jpg?v=7", "/pictures/imported/23625292-32521999.jpg?v=7", "/pictures/imported/23625292-32522001.jpg?v=7", "/pictures/imported/23625292-32522002.jpg?v=7", "/pictures/imported/23625292-32522003.jpg?v=7", "/pictures/imported/23625292-32522005.jpg?v=7", "/pictures/imported/23625292-32522006.jpg?v=7"],
        "id": "abef5133-0ebf-5ab9-9c05-fbe238f6631c",
        "marka": "OPEL",
        "modell": "AMPERA E-Pioneer (Automata)",
        "evjarat": 2012,
        "evjaratHonap": 0,
        "ar": 2870000,
        "futottKm": 226000,
        "uzemanyag": "Hibrid",
        "valto": "Automatikus",
        "leiras": "Az Opel Ampera nem csak elektromos autó, hanem benzines is. A benzinmotor nem közvetlenül a kerekeket hajtja, hanem áramot termel, így hosszabb utakon sem kell a hatótáv miatt aggódni. A mindennapi használat során rövidebb távokon tisztán elektromosan is közlekedhet. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "OPEL AMPERA E-Pioneer (Automata)",
            "bodyType": "Ferdehátú",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 5,
            "seats": 4,
            "firstRegistration": "2012",
            "inspectionValidUntil": "2027/7",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1398,
            "powerKw": 110,
            "powerHp": 150,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1657,
            "totalWeightKg": 2000,
            "trunkCapacityLiter": 310,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Fokozatmentes automata",
            "tireSummer": "215/55 R 17",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "bőr-szövet huzat",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "kulcsnélküli nyitórendszer",
                    "kulcs nélküli indítás",
                    "tolatóradar",
                    "tolatókamera",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "tempomat",
                    "tábla-felismerő funkció",
                    "guminyomás-ellenőrző rendszer",
                    "GPS nyomkövető",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "DVD",
                    "GPS (navigáció)",
                    "MP3 lejátszás",
                    "érintőkijelző",
                    "10 hangszóró",
                    "mélynyomó"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "xenon fényszóró",
                    "automata fényszórókapcsolás",
                    "automata távfény",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "garantált km futás",
                    "rendszeresen karbantartott",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 870 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 7 867"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2012"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Ferdehátú"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "226 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "4 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 657 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 000 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "310 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Hibrid (Benzin)"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 398 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "110 kW, 150 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Fokozatmentes automata"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/7"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "215/55 R 17"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "bőr-szövet huzat",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "kulcsnélküli nyitórendszer",
                            "kulcs nélküli indítás",
                            "tolatóradar",
                            "tolatókamera",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "tempomat",
                            "tábla-felismerő funkció",
                            "guminyomás-ellenőrző rendszer",
                            "GPS nyomkövető",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "xenon fényszóró",
                            "automata fényszórókapcsolás",
                            "automata távfény",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "DVD",
                            "GPS (navigáció)",
                            "MP3 lejátszás",
                            "érintőkijelző",
                            "10 hangszóró",
                            "mélynyomó"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "garantált km futás",
                            "rendszeresen karbantartott",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "226 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Hibrid (Benzin)"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "110 kW, 150 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "310 liter"
                    }
                ],
                "priceText": "2 870 000 Ft",
                "priceEur": "€ 7 867",
                "description": "Az Opel Ampera nem csak elektromos autó, hanem benzines is. A benzinmotor nem közvetlenül a kerekeket hajtja, hanem áramot termel, így hosszabb utakon sem kell a hatótáv miatt aggódni. A mindennapi használat során rövidebb távokon tisztán elektromosan is közlekedhet. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/opel/ampera/opel_ampera_e-pioneer_automata_benzines_elektromos-23625292"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23568392-31824929.jpg?v=7"),
        imageUrls: ["/pictures/imported/23568392-31824929.jpg?v=7", "/pictures/imported/23568392-31824930.jpg?v=7", "/pictures/imported/23568392-31824931.jpg?v=7", "/pictures/imported/23568392-31824933.jpg?v=7", "/pictures/imported/23568392-31824934.jpg?v=7", "/pictures/imported/23568392-31824935.jpg?v=7", "/pictures/imported/23568392-31824936.jpg?v=7", "/pictures/imported/23568392-31824937.jpg?v=7", "/pictures/imported/23568392-31824938.jpg?v=7", "/pictures/imported/23568392-31824939.jpg?v=7", "/pictures/imported/23568392-31824940.jpg?v=7"],
        "id": "8a6f55fd-de21-55f7-8c25-4a6261c537a6",
        "marka": "OPEL",
        "modell": "ASTRA J Sports Tourer 2.0 CDTI Sport (Automata)",
        "evjarat": 2011,
        "evjaratHonap": 0,
        "ar": 1990000,
        "futottKm": 265000,
        "uzemanyag": "Dízel",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "OPEL ASTRA J Sports Tourer 2.0 CDTI Sport (Automata)",
            "bodyType": "Kombi",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2011",
            "inspectionValidUntil": "2027/7",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1956,
            "powerKw": 118,
            "powerHp": 160,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1613,
            "totalWeightKg": 2155,
            "trunkCapacityLiter": 500,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata (6 fokozatú tiptronic)",
            "tireSummer": "235/40 R 19",
            "tireSummerRear": "235/40 R 19",
            "roof": "",
            "equipment": {
                "comfort": [
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "fűthető kormány",
                    "középső kartámasz",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer",
                    "sportülések"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "elektronikus rögzítőfék",
                    "tempomat",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány",
                    "sportfutómű",
                    "start-stop/motormegállító rendszer"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "USB csatlakozó",
                    "MP3 lejátszás",
                    "érintőkijelző"
                ],
                "exterior": [
                    "ködlámpa",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "1 990 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 5 455"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2011"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Kombi"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "265 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 613 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 155 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "500 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 956 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "118 kW, 160 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata (6 fokozatú tiptronic)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/7"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "235/40 R 19"
                            },
                            {
                                "label": "Hátsó nyári gumi méret",
                                "value": "235/40 R 19"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "fűthető kormány",
                            "középső kartámasz",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer",
                            "sportülések"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "elektronikus rögzítőfék",
                            "tempomat",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány",
                            "sportfutómű",
                            "start-stop/motormegállító rendszer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "ködlámpa",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "USB csatlakozó",
                            "MP3 lejátszás",
                            "érintőkijelző"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "265 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "118 kW, 160 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "500 liter"
                    }
                ],
                "priceText": "1 990 000 Ft",
                "priceEur": "€ 5 455",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/opel/astra_j/opel_astra_j_sports_tourer_2.0_cdti_sport_automata_opc_optika-23568392"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23451471-30405370.jpg?v=7"),
        imageUrls: ["/pictures/imported/23451471-30405370.jpg?v=7", "/pictures/imported/23451471-30405376.jpg?v=7", "/pictures/imported/23451471-30405380.jpg?v=7", "/pictures/imported/23451471-30405382.jpg?v=7", "/pictures/imported/23451471-30405386.jpg?v=7", "/pictures/imported/23451471-30405393.jpg?v=7", "/pictures/imported/23451471-30405399.jpg?v=7", "/pictures/imported/23451471-30405401.jpg?v=7", "/pictures/imported/23451471-30405404.jpg?v=7", "/pictures/imported/23451471-30405405.jpg?v=7", "/pictures/imported/23451471-30405407.jpg?v=7", "/pictures/imported/23451471-30405408.jpg?v=7", "/pictures/imported/23451471-30405409.jpg?v=7", "/pictures/imported/23451471-30405410.jpg?v=7"],
        "id": "3bd5f5fd-95a9-5816-94c0-a097f0061fd1",
        "marka": "OPEL",
        "modell": "INSIGNIA Sports Tourer 2.0 CDTI EcoFlex Drive Start Stop",
        "evjarat": 2015,
        "evjaratHonap": 0,
        "ar": 2970000,
        "futottKm": 193000,
        "uzemanyag": "Dízel",
        "valto": "Manuális",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "OPEL INSIGNIA Sports Tourer 2.0 CDTI EcoFlex Drive Start Stop",
            "bodyType": "Kombi",
            "condition": "Kitűnő",
            "origin": "",
            "color": "",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2015",
            "inspectionValidUntil": "2028/6",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1956,
            "powerKw": 103,
            "powerHp": 140,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1658,
            "totalWeightKg": 2300,
            "trunkCapacityLiter": 540,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (6 fokozatú)",
            "tireSummer": "245/45 R 18",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "bőr belső",
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "fűthető kormány",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "kikapcsolható légzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "hátsó fejtámlák",
                    "állítható kormány",
                    "fedélzeti komputer",
                    "sportülések"
                ],
                "safety": [
                    "tolatóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "tábla-felismerő funkció",
                    "visszagurulás-gátló",
                    "GPS nyomkövető",
                    "centrálzár",
                    "riasztó",
                    "szervokormány",
                    "sportfutómű",
                    "vonóhorog - elektromosan kihajtható"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "DVD",
                    "GPS (navigáció)",
                    "bluetooth-os kihangosító",
                    "USB csatlakozó",
                    "MP3 lejátszás",
                    "érintőkijelző",
                    "10 hangszóró"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "elektromosan behajtható külső tükrök",
                    "ködlámpa",
                    "xenon fényszóró",
                    "menetfény",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "rendszeresen karbantartott",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 970 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 8 141"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2015"
                            },
                            {
                                "label": "Állapot",
                                "value": "Kitűnő"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Kombi"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "193 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 658 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 300 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "540 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 956 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "103 kW, 140 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (6 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2028/6"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "245/45 R 18"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "bőr belső",
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "fűthető kormány",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "kikapcsolható légzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "hátsó fejtámlák",
                            "állítható kormány",
                            "fedélzeti komputer",
                            "sportülések"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "tábla-felismerő funkció",
                            "visszagurulás-gátló",
                            "GPS nyomkövető",
                            "centrálzár",
                            "riasztó",
                            "szervokormány",
                            "sportfutómű",
                            "vonóhorog - elektromosan kihajtható"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "elektromosan behajtható külső tükrök",
                            "ködlámpa",
                            "xenon fényszóró",
                            "menetfény",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "DVD",
                            "GPS (navigáció)",
                            "bluetooth-os kihangosító",
                            "USB csatlakozó",
                            "MP3 lejátszás",
                            "érintőkijelző",
                            "10 hangszóró"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "rendszeresen karbantartott",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "193 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "103 kW, 140 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Kitűnő"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "540 liter"
                    }
                ],
                "priceText": "2 970 000 Ft",
                "priceEur": "€ 8 141",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/opel/insignia/opel_insignia_sports_tourer_2.0_cdti_ecoflex_drive_start_stop_facelift-23451471"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23395211-29741106.jpg?v=7"),
        imageUrls: ["/pictures/imported/23395211-29741106.jpg?v=7", "/pictures/imported/23395211-29741110.jpg?v=7", "/pictures/imported/23395211-29741112.jpg?v=7", "/pictures/imported/23395211-29741115.jpg?v=7", "/pictures/imported/23395211-29741117.jpg?v=7", "/pictures/imported/23395211-29741119.jpg?v=7", "/pictures/imported/23395211-29741122.jpg?v=7", "/pictures/imported/23395211-29741123.jpg?v=7", "/pictures/imported/23395211-29741125.jpg?v=7", "/pictures/imported/23395211-29741126.jpg?v=7", "/pictures/imported/23395211-29741127.jpg?v=7", "/pictures/imported/23395211-29741129.jpg?v=7"],
        "id": "e316145f-a354-5039-855a-17e838448dab",
        "marka": "SKODA",
        "modell": "OCTAVIA 1.4 TSI Elegance DSG",
        "evjarat": 2013,
        "evjaratHonap": 11,
        "ar": 2970000,
        "futottKm": 229000,
        "uzemanyag": "Benzin",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "SKODA OCTAVIA 1.4 TSI Elegance DSG",
            "bodyType": "Ferdehátú",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2013/11",
            "inspectionValidUntil": "2027/5",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1395,
            "powerKw": 103,
            "powerHp": 140,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1195,
            "totalWeightKg": 1820,
            "trunkCapacityLiter": 590,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "Bézs",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata",
            "tireSummer": "205/55 R 16",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "hátsó fejtámlák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "tábla-felismerő funkció",
                    "GPS nyomkövető",
                    "centrálzár",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "bluetooth-os kihangosító",
                    "USB csatlakozó",
                    "MP3 lejátszás",
                    "érintőkijelző"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "elektromosan behajtható külső tükrök",
                    "ködlámpa",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "fűthető tükör",
                    "könnyűfém felni",
                    "színezett üveg"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "rendszeresen karbantartott",
                    "törzskönyv",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 970 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 8 141"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2013/11"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Ferdehátú"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "229 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Kárpit színe (1)",
                                "value": "Bézs"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 195 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 820 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "590 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 395 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "103 kW, 140 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/5"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "205/55 R 16"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "hátsó fejtámlák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "tábla-felismerő funkció",
                            "GPS nyomkövető",
                            "centrálzár",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "elektromosan behajtható külső tükrök",
                            "ködlámpa",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "fűthető tükör",
                            "könnyűfém felni",
                            "színezett üveg"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "bluetooth-os kihangosító",
                            "USB csatlakozó",
                            "MP3 lejátszás",
                            "érintőkijelző"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "rendszeresen karbantartott",
                            "törzskönyv",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "229 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "103 kW, 140 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "590 liter"
                    }
                ],
                "priceText": "2 970 000 Ft",
                "priceEur": "€ 8 141",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/skoda/octavia/skoda_octavia_1.4_tsi_elegance_dsg_bezs_belso-23395211"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23621849-32482781.jpg?v=7"),
        imageUrls: ["/pictures/imported/23621849-32482781.jpg?v=7", "/pictures/imported/23621849-32482783.jpg?v=7", "/pictures/imported/23621849-32482785.jpg?v=7", "/pictures/imported/23621849-32482786.jpg?v=7", "/pictures/imported/23621849-32482787.jpg?v=7", "/pictures/imported/23621849-32482789.jpg?v=7", "/pictures/imported/23621849-32482790.jpg?v=7", "/pictures/imported/23621849-32482792.jpg?v=7", "/pictures/imported/23621849-32482793.jpg?v=7", "/pictures/imported/23621849-32482795.jpg?v=7", "/pictures/imported/23621849-32482797.jpg?v=7"],
        "id": "3c12dbca-4af8-5e1a-b926-1a937aea7ead",
        "marka": "SUZUKI",
        "modell": "ALTO 1.1 GL",
        "evjarat": 2004,
        "evjaratHonap": 0,
        "ar": 450000,
        "futottKm": 61000,
        "uzemanyag": "Benzin",
        "valto": "Manuális",
        "leiras": "Igazi városi cirkáló! Tökéletes első autónak, tanulóvezetőnek vagy annak, aki egy egyszerű, olcsón fenntartható kisautót keres.\n\nExtra nincs benne, viszont pont ezért szerethető: egyszerű technika, kis fogyasztás, alacsony fenntartási költség. Négyhengeres benzines motor jön, megy, indul, teszi a dolgát.\n\nNem luxusautó, hanem egy igénytelen, praktikus kis Suzuki, amit nem kell túlgondolni. Tankolni kell és használni. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "SUZUKI ALTO 1.1 GL",
            "bodyType": "Ferdehátú",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 5,
            "seats": 4,
            "firstRegistration": "2004",
            "inspectionValidUntil": "2026/10",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1061,
            "powerKw": 46,
            "powerHp": 63,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 800,
            "totalWeightKg": 1165,
            "trunkCapacityLiter": 177,
            "climate": "",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (5 fokozatú)",
            "tireSummer": "155/65 R 13",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [],
                "safety": [],
                "multimedia": [
                    "CD-s autórádió",
                    "bluetooth-os kihangosító",
                    "MP3 lejátszás"
                ],
                "exterior": [],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "450 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 1 233"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2004"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Ferdehátú"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "61 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "4 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "800 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 165 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "177 liter"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Benzin"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 061 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "46 kW, 63 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (5 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2026/10"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "155/65 R 13"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "bluetooth-os kihangosító",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "61 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Benzin"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "46 kW, 63 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "177 liter"
                    }
                ],
                "priceText": "450 000 Ft",
                "priceEur": "€ 1 233",
                "description": "Igazi városi cirkáló! Tökéletes első autónak, tanulóvezetőnek vagy annak, aki egy egyszerű, olcsón fenntartható kisautót keres.\n\nExtra nincs benne, viszont pont ezért szerethető: egyszerű technika, kis fogyasztás, alacsony fenntartási költség. Négyhengeres benzines motor jön, megy, indul, teszi a dolgát.\n\nNem luxusautó, hanem egy igénytelen, praktikus kis Suzuki, amit nem kell túlgondolni. Tankolni kell és használni. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/suzuki/alto/suzuki_alto_1.1_gl_61.000km-23621849"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23451295-30403394.jpg?v=7"),
        imageUrls: ["/pictures/imported/23451295-30403394.jpg?v=7", "/pictures/imported/23451295-30403395.jpg?v=7", "/pictures/imported/23451295-30403396.jpg?v=7", "/pictures/imported/23451295-30403398.jpg?v=7", "/pictures/imported/23451295-30403399.jpg?v=7", "/pictures/imported/23451295-30403401.jpg?v=7", "/pictures/imported/23451295-30403402.jpg?v=7", "/pictures/imported/23451295-30403403.jpg?v=7", "/pictures/imported/23451295-30403404.jpg?v=7", "/pictures/imported/23451295-30403406.jpg?v=7", "/pictures/imported/23451295-30403407.jpg?v=7"],
        "id": "886c978e-de38-52fb-9069-7fe886ea9cb8",
        "marka": "VOLKSWAGEN",
        "modell": "GOLF VII Variant 1.6 TDI Comfortline DSG",
        "evjarat": 2014,
        "evjaratHonap": 0,
        "ar": 2790000,
        "futottKm": 276000,
        "uzemanyag": "Dízel",
        "valto": "Automatikus",
        "leiras": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "VOLKSWAGEN GOLF VII Variant 1.6 TDI Comfortline DSG",
            "bodyType": "Kombi",
            "condition": "Normál",
            "origin": "",
            "color": "",
            "doors": 5,
            "seats": 5,
            "firstRegistration": "2014",
            "inspectionValidUntil": "2027/10",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1598,
            "powerKw": 77,
            "powerHp": 105,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1335,
            "totalWeightKg": 1940,
            "trunkCapacityLiter": 605,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "5%-tól elvihető",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Automata",
            "tireSummer": "195/65 R 15",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "fűthető első ülés",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "kikapcsolható légzsák",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "állítható kormány",
                    "fedélzeti komputer",
                    "kormányváltó"
                ],
                "safety": [
                    "tolatóradar",
                    "első-hátsó parkolóradar",
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "tábla-felismerő funkció",
                    "guminyomás-ellenőrző rendszer",
                    "GPS nyomkövető",
                    "radaros fékasszisztens",
                    "távolságtartó tempomat",
                    "parkolóasszisztens",
                    "centrálzár",
                    "riasztó",
                    "szervokormány",
                    "sportfutómű",
                    "start-stop/motormegállító rendszer"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "GPS (navigáció)",
                    "kihangosító",
                    "bluetooth-os kihangosító",
                    "USB csatlakozó",
                    "MP3 lejátszás",
                    "érintőkijelző",
                    "Hi-Fi",
                    "multifunkcionális kijelző"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "xenon fényszóró",
                    "menetfény",
                    "esőszenzor",
                    "elektromos ablak elöl",
                    "elektromos ablak hátul",
                    "elektromos tükör",
                    "fűthető tükör",
                    "könnyűfém felni"
                ],
                "other": [
                    "autóbeszámítás lehetséges",
                    "azonnal elvihető",
                    "nem dohányzó",
                    "vezetett szervizkönyv",
                    "5%-tól elvihető"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "2 790 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 7 648"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2014"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Kombi"
                            },
                            {
                                "label": "Finanszírozás",
                                "value": "5%-tól elvihető"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "276 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "5"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 335 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "1 940 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "605 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 598 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "77 kW, 105 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Automata"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/10"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "195/65 R 15"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "fűthető első ülés",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "kikapcsolható légzsák",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "állítható kormány",
                            "fedélzeti komputer",
                            "kormányváltó"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "tolatóradar",
                            "első-hátsó parkolóradar",
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "tábla-felismerő funkció",
                            "guminyomás-ellenőrző rendszer",
                            "GPS nyomkövető",
                            "radaros fékasszisztens",
                            "távolságtartó tempomat",
                            "parkolóasszisztens",
                            "centrálzár",
                            "riasztó",
                            "szervokormány",
                            "sportfutómű",
                            "start-stop/motormegállító rendszer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "xenon fényszóró",
                            "menetfény",
                            "esőszenzor",
                            "elektromos ablak elöl",
                            "elektromos ablak hátul",
                            "elektromos tükör",
                            "fűthető tükör",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "GPS (navigáció)",
                            "kihangosító",
                            "bluetooth-os kihangosító",
                            "USB csatlakozó",
                            "MP3 lejátszás",
                            "érintőkijelző",
                            "Hi-Fi",
                            "multifunkcionális kijelző"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "autóbeszámítás lehetséges",
                            "azonnal elvihető",
                            "nem dohányzó",
                            "vezetett szervizkönyv",
                            "5%-tól elvihető"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "276 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "77 kW, 105 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "605 liter"
                    }
                ],
                "priceText": "2 790 000 Ft",
                "priceEur": "€ 7 648",
                "description": "Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/volkswagen/golf_vii/volkswagen_golf_vii_variant_1.6_tdi_comfortline_dsg-23451295"
    },
    {
        kepUrl: publicAssetUrl("/pictures/imported/23013383-25184564.jpg?v=7"),
        imageUrls: ["/pictures/imported/23013383-25184564.jpg?v=7", "/pictures/imported/23013383-25184619.jpg?v=7", "/pictures/imported/23013383-25184634.jpg?v=7", "/pictures/imported/23013383-25184645.jpg?v=7", "/pictures/imported/23013383-25184657.jpg?v=7", "/pictures/imported/23013383-25184685.jpg?v=7", "/pictures/imported/23013383-25184697.jpg?v=7", "/pictures/imported/23013383-25184711.jpg?v=7", "/pictures/imported/23013383-25184740.jpg?v=7", "/pictures/imported/23013383-25184764.jpg?v=7", "/pictures/imported/23013383-25184786.jpg?v=7", "/pictures/imported/23013383-25184868.jpg?v=7", "/pictures/imported/23013383-25184872.jpg?v=7"],
        "id": "ea5d75ab-1c8f-517d-ab07-c6543d9b3945",
        "marka": "VOLKSWAGEN",
        "modell": "PASSAT 1.9 PD TDI Comfortline",
        "evjarat": 2009,
        "evjaratHonap": 7,
        "ar": 1450000,
        "futottKm": 420000,
        "uzemanyag": "Dízel",
        "valto": "Manuális",
        "leiras": "Friss vezérlés, friss olaj, új kettőstömegű lendkerék.\n\n2 év műszaki vizsgával rendelkezik.\n\nKilométeréhez képest megkímélt, jó állapotú autó. Fontos megjegyezni, hogy ezek a típusok sokszor jobb állapotban vannak magasabb futásteljesítménnyel, mint a keveset futott, főként városi használatú társaik. Ennek az autónak a kilométere főként használatból adódik, viszont már átesett a nagyobb szervizeken.\n\nAz ismert és megbízható 1.9 TDI 105 lóerős motorral szerelt, ami a bevált konstrukciók közé tartozik, megfelelő karbantartás mellett akár 6-700 ezer km-t is gond nélkül teljesít.\n\nMűszakilag rendben van, jelenleg költségmentes, csak bele kell ülni és használni.\n\nTéli és nyári kerékszett jár az autóhoz.\n\nMagánszemélytől származik.\n\nAzonnal vihető, megtekinthető Sényőn. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket",
        "elkelt": false,
        "detailedData": {
            "title": "VOLKSWAGEN PASSAT 1.9 PD TDI Comfortline",
            "bodyType": "Sedan",
            "condition": "Normál",
            "origin": "",
            "color": "Fekete (metál)",
            "doors": 4,
            "seats": 5,
            "firstRegistration": "2009/7",
            "inspectionValidUntil": "2027/9",
            "documents": "Érvényes magyar okmányokkal",
            "serviceBook": "",
            "numberOfKeys": "",
            "engineDisplacementCcm": 1896,
            "powerKw": 77,
            "powerHp": 105,
            "torqueNm": 0,
            "drivetrain": "Első kerék",
            "cylinders": 0,
            "emissionClass": "",
            "environmentalClass": "",
            "combinedConsumption": "",
            "cityConsumption": "",
            "highwayConsumption": "",
            "ownWeightKg": 1616,
            "totalWeightKg": 2030,
            "trunkCapacityLiter": 485,
            "climate": "Digitális kétzónás klíma",
            "upholstery": "",
            "financing": "",
            "cylinderLayout": "Soros",
            "gearboxDetail": "Manuális (5 fokozatú)",
            "tireSummer": "205/55 R 16",
            "tireSummerRear": "",
            "roof": "",
            "equipment": {
                "comfort": [
                    "fűthető első ülés",
                    "plüss kárpit",
                    "ülésmagasság állítás",
                    "középső kartámasz",
                    "automatikusan sötétedő belső tükör",
                    "multifunkciós kormánykerék",
                    "deréktámasz",
                    "bőrkormány",
                    "függönylégzsák",
                    "hátsó oldal légzsák",
                    "ISOFIX rendszer",
                    "utasoldali légzsák",
                    "vezetőoldali légzsák",
                    "hátsó fejtámlák",
                    "állítható kormány",
                    "fedélzeti komputer"
                ],
                "safety": [
                    "ABS (blokkolásgátló)",
                    "ASR (kipörgésgátló)",
                    "ESP (menetstabilizátor)",
                    "tempomat",
                    "centrálzár",
                    "riasztó",
                    "szervokormány"
                ],
                "multimedia": [
                    "CD-s autórádió",
                    "MP3 lejátszás"
                ],
                "exterior": [
                    "automatikusan sötétedő külső tükör",
                    "ködlámpa",
                    "fényszóró magasságállítás",
                    "elektromos ablak elöl",
                    "könnyűfém felni"
                ],
                "other": [
                    "azonnal elvihető",
                    "frissen szervizelt",
                    "rendszeresen karbantartott",
                    "törzskönyv"
                ]
            },
            "haListing": {
                "sections": [
                    {
                        "title": "Ár, költségek",
                        "fields": [
                            {
                                "label": "Vételár",
                                "value": "1 450 000 Ft"
                            },
                            {
                                "label": "Vételár EUR",
                                "value": "€ 3 975"
                            }
                        ]
                    },
                    {
                        "title": "Általános adatok",
                        "fields": [
                            {
                                "label": "Évjárat",
                                "value": "2009/7"
                            },
                            {
                                "label": "Állapot",
                                "value": "Normál"
                            },
                            {
                                "label": "Kivitel",
                                "value": "Sedan"
                            }
                        ]
                    },
                    {
                        "title": "Jármű adatok",
                        "fields": [
                            {
                                "label": "Km. óra állás",
                                "value": "420 000 km"
                            },
                            {
                                "label": "Szállítható szem. száma",
                                "value": "5 fő"
                            },
                            {
                                "label": "Ajtók száma",
                                "value": "4"
                            },
                            {
                                "label": "Szín",
                                "value": "Fekete (metál)"
                            },
                            {
                                "label": "Saját tömeg",
                                "value": "1 616 kg"
                            },
                            {
                                "label": "Teljes tömeg",
                                "value": "2 030 kg"
                            },
                            {
                                "label": "Csomagtartó",
                                "value": "485 liter"
                            },
                            {
                                "label": "Klíma fajtája",
                                "value": "Digitális kétzónás klíma"
                            }
                        ]
                    },
                    {
                        "title": "Motor adatok",
                        "fields": [
                            {
                                "label": "Üzemanyag",
                                "value": "Dízel"
                            },
                            {
                                "label": "Hengerűrtartalom",
                                "value": "1 896 cm³"
                            },
                            {
                                "label": "Teljesítmény",
                                "value": "77 kW, 105 LE"
                            },
                            {
                                "label": "Henger-elrendezés",
                                "value": "Soros"
                            },
                            {
                                "label": "Hajtás",
                                "value": "Első kerék"
                            },
                            {
                                "label": "Sebességváltó",
                                "value": "Manuális (5 fokozatú)"
                            }
                        ]
                    },
                    {
                        "title": "Okmányok",
                        "fields": [
                            {
                                "label": "Okmányok jellege",
                                "value": "Érvényes magyar okmányokkal"
                            },
                            {
                                "label": "Műszaki vizsga érvényes",
                                "value": "2027/9"
                            }
                        ]
                    },
                    {
                        "title": "Abroncs",
                        "fields": [
                            {
                                "label": "Nyári gumi méret",
                                "value": "205/55 R 16"
                            }
                        ]
                    }
                ],
                "equipment": [
                    {
                        "title": "Beltér",
                        "items": [
                            "fűthető első ülés",
                            "plüss kárpit",
                            "ülésmagasság állítás",
                            "középső kartámasz",
                            "automatikusan sötétedő belső tükör",
                            "multifunkciós kormánykerék",
                            "deréktámasz",
                            "bőrkormány",
                            "függönylégzsák",
                            "hátsó oldal légzsák",
                            "ISOFIX rendszer",
                            "utasoldali légzsák",
                            "vezetőoldali légzsák",
                            "hátsó fejtámlák",
                            "állítható kormány",
                            "fedélzeti komputer"
                        ]
                    },
                    {
                        "title": "Kültér",
                        "items": [
                            "automatikusan sötétedő külső tükör",
                            "ködlámpa",
                            "fényszóró magasságállítás",
                            "elektromos ablak elöl",
                            "könnyűfém felni"
                        ]
                    },
                    {
                        "title": "Műszaki",
                        "items": [
                            "ABS (blokkolásgátló)",
                            "ASR (kipörgésgátló)",
                            "ESP (menetstabilizátor)",
                            "tempomat",
                            "centrálzár",
                            "riasztó",
                            "szervokormány"
                        ]
                    },
                    {
                        "title": "Multimédia / Navigáció",
                        "items": [
                            "CD-s autórádió",
                            "MP3 lejátszás"
                        ]
                    },
                    {
                        "title": "Egyéb információ",
                        "items": [
                            "azonnal elvihető",
                            "frissen szervizelt",
                            "rendszeresen karbantartott",
                            "törzskönyv"
                        ]
                    }
                ],
                "highlights": [
                    {
                        "label": "Km. óra állás",
                        "value": "420 000 km"
                    },
                    {
                        "label": "Üzemanyag",
                        "value": "Dízel"
                    },
                    {
                        "label": "Teljesítmény",
                        "value": "77 kW, 105 LE"
                    },
                    {
                        "label": "Állapot",
                        "value": "Normál"
                    },
                    {
                        "label": "Csomagtartó",
                        "value": "485 liter"
                    }
                ],
                "priceText": "1 450 000 Ft",
                "priceEur": "€ 3 975",
                "description": "Friss vezérlés, friss olaj, új kettőstömegű lendkerék.\n\n2 év műszaki vizsgával rendelkezik.\n\nKilométeréhez képest megkímélt, jó állapotú autó. Fontos megjegyezni, hogy ezek a típusok sokszor jobb állapotban vannak magasabb futásteljesítménnyel, mint a keveset futott, főként városi használatú társaik. Ennek az autónak a kilométere főként használatból adódik, viszont már átesett a nagyobb szervizeken.\n\nAz ismert és megbízható 1.9 TDI 105 lóerős motorral szerelt, ami a bevált konstrukciók közé tartozik, megfelelő karbantartás mellett akár 6-700 ezer km-t is gond nélkül teljesít.\n\nMűszakilag rendben van, jelenleg költségmentes, csak bele kell ülni és használni.\n\nTéli és nyári kerékszett jár az autóhoz.\n\nMagánszemélytől származik.\n\nAzonnal vihető, megtekinthető Sényőn. Minimal Car rendezett telephely, karbantartott és tiszta autók. A messzebbről érkező ügyfeleknek a teljes ügyintézés 50-60 perc, és az autót már a saját nevükre írva viszik haza. Kényelmes várakozás, nagyon finom kávé van. Google-ben: Minimal Car nézd meg az értékeléseket"
            }
        },
        "conditionSheet": {
            "tires": {
                "frontLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "frontRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearLeft": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                },
                "rearRight": {
                    "status": "Ismeretlen",
                    "lastChanged": "",
                    "note": "",
                    "treadDepthMm": ""
                }
            },
            "suspension": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakes": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "oilChange": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "timingService": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "brakeFluid": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            },
            "other": {
                "status": "Ismeretlen",
                "lastChanged": "",
                "note": ""
            }
        },
        "sourceUrl": "https://www.hasznaltauto.hu/szemelyauto/volkswagen/passat/volkswagen_passat_1.9_pd_tdi_comfortline_friss_vezerles_es_uj_komplett_kettostomegu-23013383"
    }
];
function isLikelyBuiltinCarSvgPlaceholder(kepUrl) {
    if (!kepUrl.startsWith('data:image/svg+xml'))
        return false;
    const comma = kepUrl.indexOf(',');
    if (comma < 0)
        return false;
    try {
        return decodeURIComponent(kepUrl.slice(comma + 1)).includes('Autó kép');
    }
    catch {
        return false;
    }
}
export function mergeSeedKepUrlFromDefaults(cars) {
    const seedById = new Map(carsData.map((c) => [c.id, c.kepUrl]));
    return cars.map((car) => {
        const seed = seedById.get(car.id);
        if (!seed)
            return car;
        const k = (car.kepUrl ?? '').trim();
        if (k === '' || k === CAR_IMAGE_PLACEHOLDER || isLikelyBuiltinCarSvgPlaceholder(k)) {
            return { ...car, kepUrl: seed };
        }
        return car;
    });
}
